const phoneValidation = str => {
  const number = str[0] === '+' ? `0${str.slice(3)}` : str;

  if (Number.isNaN(number) || number.length !== 11) {
    return false;
  }
  return true;
};
export default phoneValidation;
